// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Cookies from 'js-cookie'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import router from './router'
import store from './store'
import i18n from './lang' // Internationalization
import * as filters from './utils/filter/filter' // global filters

import Vant from 'vant'
import { Locale, Dialog } from 'vant';
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
import { ImagePreview } from 'vant';

Vue.use(ImagePreview);
Locale.use('en-US', enUS);
import 'vant/lib/index.css'
import './permission' // permission control

import '@/styles/index.scss' // global css
// import vConsole from '@/utils/vconsole'
// Vue.use(vConsole)
import md5 from 'js-md5';
import moment from 'moment'
Vue.prototype.$moment = moment
import { encrypt, decrypt } from '@/utils/encryp.js';
import preventReClick from '@/utils/preventReClick' //防多次点击，重复提交
Vue.use(preventReClick)
import 'lib-flexible'
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, download, resolveBlob, handleTree, startLoading, endLoading } from "@/utils/ruoyi";
Vue.use(Vant, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.prototype.$md5 = md5;
Vue.prototype.encrypt = encrypt
Vue.prototype.decrypt = decrypt
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.resolveBlob = resolveBlob
Vue.prototype.handleTree = handleTree
Vue.prototype.startLoading = startLoading
Vue.prototype.endLoading = endLoading
Vue.prototype.Cookies = Cookies
Object.keys(filters.default).forEach((item) => {
  Vue.filter(item, filters.default[item])
})

import navBar from '@/components/navBar'
import popup from '@/components/popup'
import noData from '@/components/noData'
import popupobj from '@/components/popupobj'
import DialogList from '@/components/DialogList'
Vue.component('NavBar', navBar)
Vue.component('popup', popup)
Vue.component('NoData', noData)
Vue.component('PopupObj', popupobj)
Vue.component('DialogList', DialogList)
Vue.config.productionTip = false
/* eslint-disable no-new */
const Vm = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})

export default Vm



// WEBPACK FOOTER //
// ./src/main.js